import { render } from "./CreatePreApprovedWorkloadDialog.vue?vue&type=template&id=53f6f646"
import script from "./CreatePreApprovedWorkloadDialog.vue?vue&type=script&lang=js"
export * from "./CreatePreApprovedWorkloadDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__